import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface MakeUserEmailAuthCodeRequest {
  email: string;
}

export const makeUserEmailAuthCode = ({
  email,
}: MakeUserEmailAuthCodeRequest) => {
  return api.post<ApiResponse>('/auth/email', {
    email,
  });
};

const useGetUserEmailAuthCode = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse>,
    TError,
    MakeUserEmailAuthCodeRequest,
    ['authEmail']
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  MakeUserEmailAuthCodeRequest,
  ['authEmail']
> => {
  return useMutation(makeUserEmailAuthCode, {
    ...options,
  });
};

export default useGetUserEmailAuthCode;
